import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowchevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrowchevron_down_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M225.835 353.835a42.667 42.667 0 0 1 60.33 0L512 579.669l225.835-225.834a42.667 42.667 0 1 1 60.33 60.33l-256 256a42.667 42.667 0 0 1-60.33 0l-256-256a42.667 42.667 0 0 1 0-60.33z"
    />
  </svg>
);
export default SvgArrowchevronDownIcon;
